import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Wrapper,
  InputWrapper,
  InputRight,
  Form,
  Input,
  Submit,
  Title,
  AddIcon,
  ErrorMsgLink,
  ErrorMsgName,
  Text,
} from './styled';
import { useComponentId } from './id';
import { addItem, searchItems } from '../../store/actions/action';

import { regex } from '../../regex';
import _uniqueId from 'lodash/uniqueId';
import blobOrange from '../../assets/img/blob.png';

const MainInput = () => {
  const [formData, setFormData] = useState({ link: '', title: '' });
  const [errors, setErros] = useState();
  const [isAdded, setIsAdded] = useState(false);

  const dispatch = useDispatch();

  const errorValidation = useCallback((data) => {
    const error = {};
    if (data.link.length === 0) {
      error.link = 'You forgot the link';
    } else if (!regex.test(data.link)) {
      error.link = `Hmm. That link doesn't look right`;
    }
    if (data.title.length === 0) {
      error.title = 'You forgot the title';
    }

    setErros(error);
  });

  const clearInputs = () => {
    setFormData({ link: '', title: '' });
  };

  useEffect(() => {
    errorValidation(formData);
  }, [formData]);

  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    setIsAdded(false);

    setFormData({
      ...formData,
      [name]: value,
      id: _uniqueId(),
    });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setIsAdded(true);

    if (Object.values(errors).length === 0) {
      dispatch(addItem(formData));
      setIsAdded(false);
      clearInputs();
    } else {
    }
  };

  return (
    <Wrapper>
      <Title>
        YouTube Pocket <img src={blobOrange} alt="" />
      </Title>

      <Text>
        Want to save YouTube videos with the timestamp? Go to the YouTube,
        right-click, press{' '}
        <span
          style={{ color: '#fe8300', fontWeight: '700', fontStyle: 'italic' }}
        >
          Copy video URL at current time
        </span>{' '}
        , paste it here and voila! It's just that simple.
      </Text>
      <InputWrapper>
        {errors && isAdded ? <ErrorMsgLink>{errors.link}</ErrorMsgLink> : null}
        {errors && isAdded ? <ErrorMsgName>{errors.title}</ErrorMsgName> : null}

        <Form onSubmit={onSubmitHandler}>
          <Input
            onChange={onChangeHandler}
            inputColor="white"
            type="text"
            name="link"
            value={formData.link}
            placeholder="Paste YouTube URL. . ."
          />
          <InputRight
            className="right-input"
            onChange={onChangeHandler}
            inputColor="white"
            type="text"
            name="title"
            value={formData.title}
            placeholder="Title?"
          />
          <Submit
            inputColor="white"
            type="submit"
            placeholder="Name?"
            value="click"
          >
            {/* <i class="las la-angle-down"></i> */}
            <AddIcon />
          </Submit>
        </Form>
      </InputWrapper>
    </Wrapper>
  );
};

export default MainInput;
